import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #ffffff;
  width: 20px;
  height: 20px;
`

export const WindowIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M7.45537 8.37813H11.8783V6.45521H7.45537V8.37813ZM6.46162 9.37188V5.46146H12.872V9.37188H6.46162ZM1.58995 13.25C1.16898 13.25 0.812663 13.1042 0.520996 12.8125C0.229329 12.5208 0.0834961 12.1645 0.0834961 11.7435V2.25646C0.0834961 1.83549 0.229329 1.47917 0.520996 1.1875C0.812663 0.895833 1.16898 0.75 1.58995 0.75H14.4104C14.8313 0.75 15.1877 0.895833 15.4793 1.1875C15.771 1.47917 15.9168 1.83549 15.9168 2.25646V11.7435C15.9168 12.1645 15.771 12.5208 15.4793 12.8125C15.1877 13.1042 14.8313 13.25 14.4104 13.25H1.58995ZM1.58995 12H14.4104C14.4745 12 14.5333 11.9733 14.5866 11.9198C14.6401 11.8665 14.6668 11.8077 14.6668 11.7435V3.66667H1.3335V11.7435C1.3335 11.8077 1.36023 11.8665 1.4137 11.9198C1.46704 11.9733 1.52579 12 1.58995 12Z"
        fill="#8F8BFF"
      />
    </Svg>
  )
}
